import { useTranslation } from "@impero-com/common/utils/i18n";

import * as theme from "./theme.css";

interface ValidationErrorsProps {
    errors: string[];
}

export function ValidationErrors({ errors }: ValidationErrorsProps) {
    const { t } = useTranslation();

    if (errors.length === 0) {
        return null;
    }

    return (
        <div className={theme.validationErrors}>
            <h4>{t("ControlsBulkAssign_ValidationErrors")}</h4>
            <ul>
                {errors.map((error, index) => (
                    <li key={index}>{error}</li>
                ))}
            </ul>
        </div>
    );
}
